import Vue from 'vue'/** 引入vue框架 */
import Router from 'vue-router'/** 引入路由依赖 */
import index from '@/view/index'
import login from '@/view/login'
import introduction from '@/view/introduction'
import guidelines from '@/view/guidelines'
import forum from '@/view/forum'
import star from '@/view/star'
import software from '@/view/software'
import training from '@/view/training'
import notic from '@/view/notic'
import manuscriptsList from '@/view/manuscriptsList'
import manuscriptsNewList from '@/view/manuscriptsNewList'
import manuscriptsGoodArticleList from '@/view/manuscriptsGoodArticleList'

import modificationManuscript from '@/view/contributor/modificationManuscript'
import submitManuscript from '@/view/contributor/submitManuscript'
import manuscriptList from '@/view/contributor/manuscriptList'
import manuscriptDetail from '@/view/contributor/manuscriptDetail'

import editorList from '@/view/editor/editorList'
import editorDetail from '@/view/editor/editorDetail'

import reviewerList from '@/view/reviewer/reviewerList'
import reviewerDetail from '@/view/reviewer/reviewerDetail'

// 预印本相关页面
import preprintList from '@/view/preprint/preprintList'
import preprintDetail from '@/view/preprint/preprintDetail'
import myPreprintList from '@/view/preprint/myPreprintList'
import submitPreprint from '@/view/preprint/submitPreprint'
import myCommentList from '@/view/preprint/myCommentList'
import pendingPreprintList from '@/view/preprint/admin/pendingPreprintList'
import pendingCommentList from '@/view/preprint/admin/pendingCommentList'
import auditLogList from '@/view/preprint/admin/auditLogList'
import manuscriptsIssueList from '@/view/manuscriptsIssueList'
Vue.use(Router)
/** 使用路由依赖 */
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/index',
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/introduction',
      name: 'introduction',
      component: introduction,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/guidelines',
      name: 'guidelines',
      component: guidelines,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/forum',
      name: 'forum',
      component: forum,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/star',
      name: 'star',
      component: star,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/software',
      name: 'software',
      component: software,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/training',
      name: 'training',
      component: training,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/notic',
      name: 'notic',
      component: notic,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/manuscriptsList',
      name: 'manuscriptsList',
      component: manuscriptsList,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/manuscriptsNewList',
      name: 'manuscriptsNewList',
      component: manuscriptsNewList,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/manuscriptsGoodArticleList',
      name: 'manuscriptsGoodArticleList',
      component: manuscriptsGoodArticleList,
      meta: {
        loginNeedShow: true
      }
    },

    {
      path: '/modificationManuscript',
      name: 'modificationManuscript',
      component: modificationManuscript,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/submitManuscript',
      name: 'submitManuscript',
      component: submitManuscript,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/editorList',
      name: 'editorList',
      component: editorList,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/editorDetail',
      name: 'editorDetail',
      component: editorDetail,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/reviewerList',
      name: 'reviewerList',
      component: reviewerList,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/reviewerDetail',
      name: 'reviewerDetail',
      component: reviewerDetail,
      meta: {
        loginNeedShow: false
      }

    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/manuscriptList',
      name: 'manuscriptList',
      component: manuscriptList,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/manuscriptDetail',
      name: 'manuscriptDetail',
      component: manuscriptDetail,
      meta: {
        loginNeedShow: false
      }
    },

    // 预印本路由
    {
      path: '/preprintList',
      name: 'preprintList',
      component: preprintList,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/preprintDetail',
      name: 'preprintDetail',
      component: preprintDetail,
      meta: {
        loginNeedShow: true
      }
    },
    {
      path: '/myPreprintList',
      name: 'myPreprintList',
      component: myPreprintList,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/submitPreprint',
      name: 'submitPreprint',
      component: submitPreprint,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/myCommentList',
      name: 'myCommentList',
      component: myCommentList,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/pendingPreprintList',
      name: 'pendingPreprintList',
      component: pendingPreprintList,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/pendingCommentList',
      name: 'pendingCommentList',
      component: pendingCommentList,
      meta: {
        loginNeedShow: false
      }
    },
    {
      path: '/auditLogList',
      name: 'auditLogList',
      component: auditLogList,
      meta: {
        loginNeedShow: false
      }
    },
    {
     path: '/manuscriptsIssueList',
     name: 'manuscriptsIssueList',
     component: manuscriptsIssueList
   }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js